import { use } from "passport";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/LinkIcon";

import "./styles.less";

export const GuardFeature = ({ title, subTitle, btnLinks } = {}) => {
  const { t } = useTranslation();
  const defaultBtnLinks = [
    {
      text: t("common.button.linkDoc"),
      link: "https://docs.authing.cn/v2/reference/ui-components/",
    },
    {
      text: t("common.button.linkDoc"),
      link: "https://docs.authing.cn/v2/reference/ui-components/",
    },
    {
      text: t("common.button.linkDoc"),
      link: "https://docs.authing.cn/v2/reference/ui-components/",
    },
    {
      text: t("common.button.linkDoc"),
      link: "https://docs.authing.cn/v2/reference/ui-components/",
    },
  ];
  const cardList = [
    {
      icon: "//files.authing.co/authing-website/guard-function-icon-1.png",
      title: t("learn.guard.features.item1.title"),
      subtitle: t("learn.guard.features.item1.subtitle"),
      linkUrl: "",
    },
    {
      icon: "//files.authing.co/authing-website/guard-function-icon-2.png",
      title: t("learn.guard.features.item2.title"),
      subtitle: t("learn.guard.features.item2.subtitle"),
      linkUrl: "",
    },
    {
      icon: "//files.authing.co/authing-website/guard-function-icon-3.png",
      title: t("learn.guard.features.item3.title"),
      subtitle: t("learn.guard.features.item3.subtitle"),
      linkUrl: "",
    },
    {
      icon: "//files.authing.co/authing-website/guard-function-icon-4.png",
      title: t("learn.guard.features.item4.title"),
      subtitle: t("learn.guard.features.item4.subtitle"),
      linkUrl: "",
    },
  ];
  return (
    <div className="guard-feature-warp">
      <div className="guard-feature-headline">
        {title || t("learn.guard.features.title")}
      </div>
      {subTitle && <div>{subTitle}</div>}
      <div className="guard-feature">
        {cardList.map((card, index) => {
          const btnLink = (btnLinks || defaultBtnLinks)[index];

          return (
            <div key={index} className="guard-feature-card">
              <div className="guard-feature-icon">
                <img src={card.icon} alt="authing" />
              </div>
              <div className="guard-feature-title">{card.title}</div>
              <div className="guard-feature-subtitle">{card.subtitle}</div>
              <Link target="_blank" href={btnLink.link}>
                {btnLink.text}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};
